// eslint-disable no-unused-vars
<template>
  <div id="app" :class="{ 'fix-ie': showLoader }">
    <div id="nprogress-container" />
    <ald-loader v-if="showLoader" :text="`${loaderText}...`" />
    <router-view />
    <dialog-error ref="dialogError" :config="errorConfig" />
  </div>
</template>

<script>
import DialogError from 'views/Error/Dialog';
import InjectScriptMixin from 'mixins/InjectScriptMixin';

export default {
  name: 'AldAutomotive',

  components: {
    DialogError
  },
  mixins: [InjectScriptMixin],

  data() {
    return {
      errorConfig: {}
    };
  },
  computed: {
    showLoader() {
      return this.$store.getters['ui/dataUI']('loader');
    },

    loaderText() {
      return (
        this.$store.getters['ui/dataUI']('loaderText') || this.$t('message.generic.loadingData')
      );
    }
  },
  // eslint-disable no-unused-vars
  mounted() {
    this.$cookiebot.consentBanner();
    this.setTheme(this.$store.getters['ui/dataUI']('theme'));

    if (process.env.NODE_ENV === 'production' && process.env.FACEBOOK_APP_ID) {
      this.injectScriptCode(
        'facebook-pixel',
        `!(function(f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function() {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', ${process.env.FACEBOOK_APP_ID});
      fbq('track', 'PageView');`,
        'script'
      );
      this.injectScriptCode(
        'facebook-pixel-noscript',
        `<img
        height="1"
        width="1"
        style="display:none"
        src="https://www.facebook.com/tr?id=${process.env.FACEBOOK_APP_ID}&ev=PageView&noscript=1"
    />`,
        'noscript'
      );
    }

    this.$store.watch(
      getters => getters.ui.theme,
      val => {
        this.setTheme(val);
      }
    );

    this.$store.watch(
      getters => getters.error,
      val => {
        if (val) {
          if (val.dialog) {
            this.errorConfig = JSON.parse(JSON.stringify(val));
            this.$refs.dialogError.show();
          } else {
            this.$router.push({ name: 'error' });
          }
          this.$store.dispatch('RESET_ERROR_PROPERTY');
        }
      }
    );
  },

  methods: {
    setTheme(theme) {
      this.$el.parentElement.className = `theme-${theme}`;
    }
  }
};
</script>
